import React from 'react';
import { i18n } from 'config/locales';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired,
  CommonAddressBooks
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { LocationItemModel } from 'forms/shared/types';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import Field from 'components/Form/Field';
import PVQLocation from 'components/Form/PVQLocation';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  formType?: string
  allowNotApplicable?: boolean,
  addressBook?: string,
  addressBooks?: CommonAddressBooks,
  cityLabel?: string,
  countryLabel?: string,
  countyLabel?: string,
  domesticTitle?: string,
  excludeUnitedStates?: boolean,
  foreignTitle?: string,
  includeMilitaryStates?: boolean,
  label?: string,
  name?: string,
  showDisabledText?: boolean,
  showInternationalStreet?: boolean,
  showMilitaryInstallation?: boolean,
  showPostOffice?: boolean,
  stateLabel?: string,
  street2Label?: string,
  streetLabel?: string,
  useChangeWarning?: boolean,
  zipcodeLabel?: string,
dispatch?:()=>{},
geocode:boolean,
isPoBoxAllowed: boolean,
}

interface ItemProps
  extends Props,
  Partial<LocationItemModel>,
    Omit<AccordionItemProps, 'name'> {}

export default class LocationCollectionItem extends ValidationElement<ItemProps> {
  update = (queue: Partial<LocationItemModel>) => {
    this.props.onUpdate({
      Has: this.props.Has,
      Location: this.props.Location,
      ...queue,
    });
  };

  updateLocation = (values: LocationItemModel['Location']) => {
    this.update({ Location: values });
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;

    return (
      <Field
        optional
        scrollIntoView={this.props.scrollIntoView}
        className="minimal-margin-bottom"
        attribute={`${attribute}.Location`}
        exactAttribute
      >
        <PVQLocation
          {...this.props.Location}
          addressBook={this.props.addressBook}
          addressBooks={this.props.addressBooks}
          attribute={`${attribute}.Location`}
          cityLabel={this.props.cityLabel}
          countryLabel={this.props.countryLabel}
          countyLabel={this.props.countyLabel}
          dispatch={this.props.dispatch}
          domesticTitle={this.props.domesticTitle}
          excludeUnitedStates={this.props.excludeUnitedStates}
          foreignTitle={this.props.foreignTitle}
          formType={this.props.formType}
          geocode={this.props.geocode}
          includeMilitaryStates={this.props.includeMilitaryStates}
          isPoBoxAllowed={this.props.isPoBoxAllowed}
          label={this.props.label}
          name={this.props.name}
          onError={this.props.onError}
          onUpdate={this.updateLocation}
          required={this.props.required}
          showDisabledText={this.props.showDisabledText}
          showInternationalStreet={this.props.showInternationalStreet}
          showMilitaryInstallation={this.props.showMilitaryInstallation}
          showPostOffice={this.props.showPostOffice}
          stateLabel={this.props.stateLabel}
          street2Label={this.props.street2Label}
          streetLabel={this.props.streetLabel}
          useChangeWarning={this.props.useChangeWarning}
          zipcodeLabel={this.props.zipcodeLabel}
          showApoFpoDpoPostcodeWhenForeign={this.props.showApoFpoDpoPostcodeWhenForeign}
          hideInstallationNameUnknownWhenForeign={this.props.hideInstallationNameUnknownWhenForeign}
        />
      </Field>
    );
  }
}

LocationCollectionItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  name: 'location',
  street: '',
  validated: false,
  geocode: false,
  streetLabel: i18n.t('address.pvq.us.street.label'),
  street2Label: i18n.t('address.pvq.us.street2.label'),
  stateLabel: i18n.t('address.pvq.us.state.label'),
  cityLabel: i18n.t('address.pvq.us.city.label'),
  zipcodeLabel: i18n.t('address.pvq.us.zipcode.label'),
  countyLabel: i18n.t('address.pvq.us.county.label'),
  countryLabel: i18n.t('address.pvq.international.country.label'),
  required: false,
  addressBooks: {},
  addressBook: '',
  isPoBoxAllowed: true,
  includeMilitaryStates: false,
  excludeUnitedStates: true,
  showPostOffice: false,
  showMilitaryInstallation: false,
  showInternationalStreet: false,
  showDisabledText: false,
  dispatch: () => { },
  useChangeWarning: false,
  showApoFpoDpoPostcodeWhenForeign: false,
  hideInstallationNameUnknownWhenForeign: false,

  formType: '',
  Telephone: {},
  Has: {},
};
